
import axios from 'axios';

const BASE_API_URL = typeof process.env.REACT_APP_API_END_POINT !== 'undefined' ? process.env.REACT_APP_API_END_POINT : ""

class Api {
  
  get = async (url: string, params?: any) => {    
    const response = await axios.get((BASE_API_URL + url),{ params });    
    return response;
  };

  post = async (url: string, payload: any, params?: any) => {
    const response = await axios.post(BASE_API_URL + url, payload, { params });
    return response;
  };

  put = async (url: string, payload: any, params?: any) => {
    const response = await axios.put(BASE_API_URL + url, payload, { params });
    return response;
  };

  delete = async (url: string, payload?: any) => {
    const response = await axios.delete((BASE_API_URL + url), { data: payload });
    return response;
  };

  patch = async (url: string, payload?: any) => {
    const response = await axios.patch(BASE_API_URL + url, payload);
    return response;
  };
}

export default new Api();
